var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.2976 28.7331C94.9302 23.1335 91.5392 18.1031 87.2282 13.7766C82.9171 9.4604 77.8824 6.06542 72.2894 3.69515C66.4999 1.24207 60.3383 0 54.001 0C45.6063 0 37.3667 2.24607 30.1713 6.48979C23.2653 10.5679 17.4862 16.3642 13.4336 23.2887L14.1263 23.6924C22.3969 9.56391 37.6458 0.807343 54.001 0.807343C79.4745 0.807343 100.192 21.5498 100.192 47.0536C100.192 72.4642 79.6192 93.1549 54.2698 93.2999V94.1072C60.5244 94.0761 66.5826 92.8341 72.2997 90.412C77.8927 88.0418 82.9171 84.6468 87.2385 80.3306C91.5496 76.0144 94.9405 70.9737 97.308 65.3741C99.7582 59.5778 100.999 53.4088 100.999 47.0639C100.999 40.7191 99.7478 34.5398 97.2976 28.7331Z",
    fill: "#6F5C91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81763 47.043C9.81763 40.3254 11.3374 33.7011 14.2528 27.7081C14.8007 26.5799 14.3975 25.224 13.312 24.603L13.2603 24.5719C12.061 23.8784 10.531 24.3442 9.92102 25.5966C8.58738 28.3395 7.5122 31.1963 6.71615 34.1255C5.57894 38.3174 5 42.6647 5 47.043C5 53.6673 6.29228 60.095 8.85617 66.1397C11.327 71.9774 14.8524 77.2252 19.3599 81.738C23.857 86.2405 29.0985 89.7804 34.9396 92.2542C39.9123 94.3553 45.1435 95.6077 50.5194 95.9907C51.9047 96.0839 53.073 94.9971 53.073 93.6101V93.5583C53.073 92.2956 52.1012 91.2709 50.8399 91.1777C27.9406 89.532 9.81763 70.3627 9.81763 47.043Z",
    fill: "#6F5C91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_691_1599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0035 87.2468C76.1798 87.2468 94.1573 69.248 94.1573 47.0453C94.1573 24.8426 76.1798 6.84375 54.0035 6.84375C31.8271 6.84375 13.8496 24.8426 13.8496 47.0453C13.8496 69.248 31.8271 87.2468 54.0035 87.2468Z",
    fill: "url(#paint0_linear_691_1599)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7139 86.2428C75.1652 86.2428 92.5548 68.8325 92.5548 47.3558C92.5548 25.8791 75.1652 8.46875 53.7139 8.46875C32.2627 8.46875 14.873 25.8791 14.873 47.3558C14.873 68.8325 32.2627 86.2428 53.7139 86.2428Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4153 52.7891H41.7462L40.0801 57.2724V62.0325H48.9137",
    stroke: "#6F5C91",
    strokeWidth: 0.606625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8733 52.7891L47.1218 57.2749V62.0349M50.2451 54.2336C51.2221 54.4081 51.8906 54.7623 51.8906 55.1707C51.8906 55.5364 51.3566 55.8584 50.5457 56.047M47.2531 56.061C46.4074 55.8749 45.8457 55.5454 45.8457 55.1716C45.8457 54.7598 46.5205 54.4048 47.5047 54.2311",
    stroke: "#6F5C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4153 52.7891H56.0171L57.7473 57.2724M57.7473 57.2724H50.7079M57.7473 57.2724V62.0325H48.9137M47.121 57.2724H40.0801",
    stroke: "#6F5C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9564 52.7764L50.5228 56.1546L50.7079 57.2622V62.0223M42.9067 54.491H44.2413M42.334 55.9594H43.6686M54.1493 54.491H52.8147M54.7221 55.9594H53.3859M46.2864 49.5234H39.6173L37.9512 54.0068",
    stroke: "#6F5C91",
    strokeWidth: 0.606625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9512 54.0084V58.7685H40.0595M45.7437 49.5234L45.2184 52.6578L45.201 52.7608M48.1154 50.9671C49.0925 51.1417 49.761 51.4958 49.761 51.9051C49.761 52.2708 49.227 52.5928 48.4161 52.7814M44.9771 52.7608C44.2137 52.5697 43.716 52.2576 43.716 51.9043C43.716 51.4942 44.3909 51.1384 45.375 50.9655M46.2864 49.5259H53.9531L55.1635 52.7814M41.1963 54.0076H37.9512M47.8275 49.5234L48.3678 52.7468M40.777 51.238H42.1117M52.0196 51.238H50.685M65.4741 54.3774C65.4741 55.3187 63.9837 56.0821 62.1451 56.0821C60.3066 56.0821 58.8145 55.3187 58.8145 54.3774M65.4741 56.89C65.4741 57.8313 63.9837 58.5947 62.1451 58.5947C60.3066 58.5947 58.8145 57.8313 58.8145 56.89M65.4741 51.8417C65.4741 52.7838 63.9837 53.5464 62.1451 53.5464C60.3058 53.5464 58.8145 52.7838 58.8145 51.8417C58.8145 50.8996 60.3058 50.137 62.1451 50.137C63.9837 50.137 65.4741 50.8996 65.4741 51.8417Z",
    stroke: "#6F5C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.816 51.8403L58.8152 59.4008C58.8152 60.343 60.3072 61.1057 62.1458 61.1057C63.9843 61.1057 65.4748 60.343 65.4748 59.4008C67.3141 59.4008 68.8054 58.6374 68.8054 57.696M62.145 50.1346V45.1107M64.9606 43.4051V32.4892C64.9604 32.1336 64.8245 31.7925 64.5828 31.5411C64.3412 31.2897 64.0135 31.1484 63.6718 31.1484H42.4137C42.0721 31.1484 41.7444 31.2897 41.5027 31.5411C41.2611 31.7925 41.1252 32.1336 41.125 32.4892V49.4799",
    stroke: "#6F5C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8052 52.6719C68.8052 53.6132 67.314 54.3766 65.4746 54.3766M68.8052 55.1845C68.8052 56.1258 67.314 56.8892 65.4746 56.8892",
    stroke: "#6F5C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0312 45.0765L49.884 38.5755L56.0017 42.3992L59.4462 35.7812",
    stroke: "#6F5C91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4766 59.4003C67.3167 59.4003 68.8072 58.6368 68.8072 57.6955V45.1094",
    stroke: "#6F5C91",
    strokeWidth: 0.606625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8043 47.6314C68.8043 48.5735 67.313 49.3361 65.4737 49.3361C63.6343 49.3361 62.1447 48.5735 62.1447 47.6314M68.8043 50.144C68.8043 51.0862 67.313 51.8488 65.4737 51.8488L65.4745 59.4088M57.2168 55.8956H58.8149M68.8043 45.1188C68.8043 46.0609 67.313 46.8243 65.4737 46.8243C63.6351 46.8243 62.1447 46.0609 62.1447 45.1196C62.1447 44.1775 63.6351 43.4141 65.4745 43.4141C67.3138 43.4141 68.8043 44.1775 68.8043 45.1188Z",
    stroke: "#6F5C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_691_1599",
    x: 0.908272,
    y: 0.373081,
    width: 145.015,
    height: 145.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 19.412,
    dy: 25.8827
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.1767
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_691_1599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_691_1599",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_1599",
    x1: 78.9974,
    y1: 78.5039,
    x2: 28.9332,
    y2: 15.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.89e09f30c12321ad8bf2a462c3b37174.svg";
export { ForwardRef as ReactComponent };